<template>
    <b-modal :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" ref="mdlRsaAccessoAdi" scrollable>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label for="" class="sa-label-data">Data Ora Inizio</label>
                <date-picker v-model="jsonData.dataOraInizio" format="DD/MM/YYYY HH:mm" value-type="timestamp" :disabled="stato === 'CHIUSO'" type="datetime"> </date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label for="" class="sa-label-data">Data Ora Fine</label>
                <date-picker v-model="jsonData.dataOraFine" format="DD/MM/YYYY HH:mm" value-type="timestamp" :disabled="stato === 'APERTO'" type="datetime"> </date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label for="" class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonData.note" rows="6" no-resize></b-form-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button @click="onClickCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button @click="onClickSalva" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"> </modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import DatePicker from "vue2-datepicker";
/* import RsaAccettazionePostiLettoListComponent from "./RsaAccettazionePostiLettoListComponent.vue"; */

export default {
    name: "RsaAssegnaPostoLettoModalEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError, DatePicker },
    props: {},
    computed: {},
    data() {
        return {
            pathResource: "/rsaadiaccessi",
            title: null,
            id: null,
            idAccettazione: null,
            stato: null,
            jsonData: {
                idAccettazione: null,
                dataOraInizio: null,
                dataOraFine: null,
                stato: null,
                note: "",
                latitudine: 0,
                longitudine: 0,
            },
        };
    },
    watch: {},
    methods: {
        show(idAccettazione, stato) {
            let me = this;
            me.stato = stato;
            me.idAccettazione = idAccettazione;
            me.title = stato === "APERTO" ? "APERTURA ACCESSO" : "CHIUSURA ACCESSO";
            if (me.stato === "APERTO") {
                me.jsonData = { idAccettazione: idAccettazione, dataOraInizio: new Date().getTime(), note: "", dataOraFine: null, id: null };
            } else {
                me.recuperaAccessoAperto();
            }

            me.$refs.mdlRsaAccessoAdi.show();
        },
        recuperaAccessoAperto() {
            let me = this;
            me.loadDataResources(me.pathResource + "/aperto/" + me.idAccettazione, {}, me.resultResponseRecuperaAccesso, me.resultErrorRecuperaAccesso);
        },
        resultResponseRecuperaAccesso(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.dataOraFine = new Date().getTime();
        },
        resultErrorRecuperaAccesso(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore nel recupero Accesso";
            this.$bvToast.toast(messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickSalva() {
            let me = this;
            let pathresource = me.jsonData.id ? me.pathResource + "/chiusura" : me.pathResource + "/apertura";
            me.saveResource(pathresource, me.jsonData, me.resultResponseSave, null);
        },
        resultResponseSave(response) {
            let me = this;
            me.$emit("afterSaveAccesso", response.data.data);
            me.$refs.mdlRsaAccessoAdi.hide();
        },
        onClickCloseModal() {
            let me = this;
            me.$refs.mdlRsaAccessoAdi.hide();
        },
    },
};
</script>

<style></style>
